import React from "react";

export const RowContext =
    React.createContext<any>(null);
export default RowContext;